import React, { ReactNode } from 'react'
import { LinkProps } from 'react-router'
import { IconFa, Text } from '../../atoms'

export const Breadcrumbs = ({
  crumbs,
  currentPage,
  children,
  ...props
}: {
  children?: ReactNode
  currentPage: ReactNode
  crumbs: Array<{ to: string; name: ReactNode }>
  as: React.ElementType<React.RefAttributes<HTMLAnchorElement> & LinkProps>
}) => {
  const Link = props.as
  return (
    <div>
      <div>
        {crumbs.map((link, index) => (
          <React.Fragment key={link.name + (index + '')}>
            <Link className="text-sm underline text-primary-500 cursor-pointer font-semibold" to={link.to}>
              {link.name}
            </Link>
            <IconFa icon={['far', 'chevron-right']} className="mx-2 text-sm w-6" />
          </React.Fragment>
        ))}
        <Text as="span" textType="sm">
          {currentPage}
        </Text>
      </div>
      {children && <div className="mt-4">{children}</div>}
    </div>
  )
}
